import { render, staticRenderFns } from "./calculations-starter.vue?vue&type=template&id=6d2a4b4e&"
import script from "./calculations-starter.vue?vue&type=script&lang=js&"
export * from "./calculations-starter.vue?vue&type=script&lang=js&"
import style0 from "./calculations-starter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports